"use strict";
var SelectableItemViewModel = (function () {
    function SelectableItemViewModel() {
    }
    return SelectableItemViewModel;
}());
exports.SelectableItemViewModel = SelectableItemViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/item-selector/selectable-item-view.model.js